import { ICommonLink } from '@src/models/common';

export const DOCUMENT: ICommonLink = {
  id: 'documentsLink',
  href: '/document',
  name: 'Документы',
  disableNextJs: true,
  tags: [
    'role.account-manager',
    'role.finCoordinator',
    'role.agency-primary-manager',
    'role.agency-manager',
    'role.client-manager',
    'role.client-primary-manager',
  ],
};
